import { action, observable, makeObservable } from 'mobx';

import { t } from '@gem/modules/i18n';

import { PayloadType, VoiceTranscriptionStatus } from 'APP/model/message/messageModel.types';

import { FilePayload } from '../FilePayload/FilePayload';

export class VoicePayload extends FilePayload {
  histogram = '';
  @observable transcriptionText = null;
  @observable transcriptionStatus = VoiceTranscriptionStatus.TranscriptionSuccessful;

  constructor(data) {
    super(data);

    makeObservable(this);

    this.payloadType = PayloadType.VoiceMessage;
    this.duration = data.duration;
    this.histogram = data.histogram;
    this.transcriptionText = data.transcriptionText;
    this.transcriptionStatus = data.transcriptionStatus || VoiceTranscriptionStatus.NotTranscribed;
  }

  @action
  setTranslationStatus(status) {
    this.transcriptionStatus = status;
  }

  get typeDescription() {
    return t('message_desctription_voice_message');
  }

  toJSON() {
    return {
      ...super.toJSON(),
      duration: this.duration,
      url: this.url,
      histogram: this.histogram,
      transcriptionText: this.transcriptionText || null,
      transcriptionStatus: this.transcriptionStatus,
    };
  }
}
